import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown } from "lucide-react";

// Up/down arrows shared by field and divider rows.
export const OrderButtons = ({ onMove, isFirst, isLast, kind, itemKey }) => (
  <div className="sm:col-span-1 flex items-center gap-0.5">
    <Button size="sm" variant="ghost" className="h-8 w-8 p-0"
            onClick={() => onMove("up")} disabled={isFirst} title="Move up"
            data-testid={`fd-${kind}-up-${itemKey}`}>
      <ArrowUp className="h-4 w-4" />
    </Button>
    <Button size="sm" variant="ghost" className="h-8 w-8 p-0"
            onClick={() => onMove("down")} disabled={isLast} title="Move down"
            data-testid={`fd-${kind}-down-${itemKey}`}>
      <ArrowDown className="h-4 w-4" />
    </Button>
  </div>
);
